<template>
  <PopupDialog
    v-model:open="open"
    :title="title"
    :description="message"
    required
    z-class="z-40"
    :backdrop-class="backdropClass"
    :content-class="contentClass"
    tab-order-actions-first
    reverse-actions-order
  >
    <textarea
      v-if="showComment"
      v-model="comment"
      class="textarea text-base-content my-4 h-24 w-full"
      :placeholder="$t('offer.add-comment')"
    ></textarea>
    <template #actions>
      <button class="btn btn-primary" @click="confirm">
        <FontAwesomeIcon v-if="confirmIcon" :icon="confirmIcon" />
        {{ confirmText }}
      </button>
      <button class="btn btn-neutral" @click="cancel">
        <FontAwesomeIcon v-if="cancelIcon" :icon="cancelIcon" />
        {{ cancelText }}
      </button>
    </template>
  </PopupDialog>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useConfirmDialog } from '../../composables/dialog/useConfirmDialog';
import PopupDialog from './PopupDialog.vue';
import { computed } from 'vue';

const {
  open,
  title,
  message,
  confirmText,
  cancelText,
  confirm,
  confirmIcon,
  cancel,
  cancelIcon,
  comment,
  showComment,
  highlight,
} = useConfirmDialog();

const contentClass = computed(() => {
  if (!highlight.value) return 'bg-base-100';
  switch (highlight.value) {
    case 'primary':
      return 'bg-primary text-primary-content';
    case 'secondary':
      return 'bg-secondary text-secondary-content';
    case 'success':
      return 'bg-success text-success-content';
    case 'error':
      return 'bg-error text-error-content';
    case 'warning':
      return 'bg-warning text-warning-content';
    case 'info':
      return 'bg-info text-info-content';
  }
});

const backdropClass = computed(() => {
  if (!highlight.value) return 'bg-black/50';
  switch (highlight.value) {
    case 'primary':
      return 'bg-primary/50';
    case 'secondary':
      return 'bg-secondary/50';
    case 'success':
      return 'bg-success/50';
    case 'error':
      return 'bg-error/50';
    case 'warning':
      return 'bg-warning/50';
    case 'info':
      return 'bg-info/50';
  }
});
</script>
